import increaseColorPointByRatio from '../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { secondaryColor, backgroundColor, secondaryColorPalette } = params;
  const fallback = {
    rule: 'priceLabel.background.light',
    params,
  };

  return increaseColorPointByRatio(
    {
      targetColor: secondaryColor,
      backgroundColor,
      targetColorPalette: secondaryColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    },
    '50'
  );
};

export default light;
